import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { IMAGES } from "../assets/img/ImageIndex";

const TestimonialsSlider = () => {
  const items = [
    {
      id: 1,
      text:
        "It felt like their team member was honest and truly helpful. They were able to get us exactly what we needed at a fair rate. It’s a tough world for small business to find financing that doesn’t suck worse than going bankrupt. Glad a company like EnvoCapital exist to fill the gap left by traditional finance and banking. Good job to Mr. Rack who helped us in the whole process. We really appreciate you buddy.",
      img: IMAGES.userPlaceholder,
      name: "Jodie Clark",
      time: "June 3, 2025",
    },
    {
      id: 2,
      text:
        "I was in desperate need of additional funds for a business deal just before the holidays. Hesitant to touch the funds that my family had set aside for holiday shopping for business purposes. With my credit score being only fair, I was nervous and hesitant about applying. Alex from Envocapital was with me from beginning to end and answered every question without hesitation.",
      img: IMAGES.geniuszReview,
      name: "Shannan Geniusz",
      time: "December 1, 2025",
    },
    {
      id: 3,
      text:
        "I was treated with respect and complete professionalism. The knowledge and efficiency with this process than I ever expected! Thank you to the customer service representatives that I spoke to for walking me through the process and making it so easy, especially Zach and the young lady who finalized everything, I'm sorry I didn't get your name-exceptional service!",
      img: IMAGES.userPlaceholder,
      name: "Lewis Livingston",
      time: "December 5, 2025",
    },
    {
      id: 4,
      text:
        "Very easy, no hassle process. Did everything online from the comfort of my home. I applied for the line of credit for my business on Saturday and the funds went into my account on the next Monday. With the interest rate I gor with this loan, I'm saving a ton each month. Couldn't be happier. I highly recommend Envocapital.",
      img: IMAGES.userPlaceholder,
      name: "Madyson Peterson",
      time: "October 11, 2025",
    },
    {
      id: 5,
      text:
        "The speed of getting approved for the loan was very good. Loan approval from the time I filled out the loan application, to supplying documents, linking my bank account, taking a pic of my drivers license and pay stub, all occurred in 5 hours. The money got deposited within 10 days. I want to shout out Alex from Envocapital for his help. Thank You Guys.",
      img: IMAGES.userPlaceholder,
      name: "Maria",
      time: "July 22, 2025",
    },
  ];


  return (
    <div className="owl-testimonials-slide position-relative">
      <Swiper
        modules={[Pagination, Navigation, Autoplay, A11y]}
        slidesPerView={1}
        loop
        // pagination={{ clickable: true }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        autoplay={{ delay: 4500, disableOnInteraction: false }}
        speed={700}
        className="testimonials-swiper"
      >
        {items.map((t) => (
          <SwiperSlide key={t.id}>
            <div className="testimonials-single-item position-relative z-1">
              <ul className="ps-0 list-unstyled d-flex justify-content-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <i className="ri-star-fill"></i>
                  </li>
                ))}
              </ul>

              <p>{t.text}</p>

              <div className="d-flex justify-content-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="flex-shrink-0">
                    <img
                      decoding="async"
                      src={t.img}
                      className="rounded-circle img"
                      alt="author"
                    />
                  </div>

                  <div className="flex-grow-1 ms-3 text-start">
                    <h3>{t.name}</h3>
                    <span>{t.time}</span>
                  </div>
                </div>
              </div>

              {/* keep decorative shape */}
              <img
                decoding="async"
                src={IMAGES.shape1}
                className="shape shape-1"
                alt="shape1"
              />
            </div>
          </SwiperSlide>
        ))}

        {/* Optional nav buttons that reuse your icon classes */}
        <div className="swiper-button-prev reviewSliderPrev">
          {/* <i className="fi fi-rs-arrow-left" /> */}
          <i className="fi fi-rs-arrow-left"></i>
        </div>
        <div className="swiper-button-next reviewSliderNext">
          {/* <i className="fi fi-rs-arrow-right" /> */}
          <i className="fi fi-rs-arrow-right"></i>
        </div>
      </Swiper>
    </div>
  );
};

export default TestimonialsSlider;
